const ERROR_MODAL_EVENT = 'turn4:show-error-modal';

let lastShownKey: string | null = null;

function errorKey(error: Error): string {
  const apiLike = error as { subCode?: string; statusCode?: number };
  if (apiLike.subCode) return apiLike.subCode;
  if (apiLike.statusCode) return String(apiLike.statusCode);
  return error.message;
}

/**
 * Dispatch from anywhere (including module-scope code outside React)
 * to trigger the ErrorModal. The ErrorModal component listens for this event.
 *
 * Duplicate errors (same subCode + statusCode + message) are suppressed so that
 * re-firing queries don't keep re-opening the modal after the user dismisses it.
 * A genuinely different error will still show.
 */
export function dispatchErrorModal(error: Error) {
  const key = errorKey(error);
  if (key === lastShownKey) return;
  lastShownKey = key;
  window.dispatchEvent(new CustomEvent(ERROR_MODAL_EVENT, { detail: error }));
}

/** Call when the underlying condition changes (e.g. dealer switch) to allow the same error to show again. */
export function resetErrorModalSuppression() {
  lastShownKey = null;
}

export { ERROR_MODAL_EVENT };
